import APICaller from '../library/APICaller'
import { AUTH_GROUP } from '../constants/constants'

const UserServices = {
  putUserReceive (userId, receiveSMS) {
    return APICaller.put(`/api/v1/users/receive`, {userId, receiveSMS})
  },
  
  postUsers (user = {customerCode, customerDeptCode, customerDeptName, customerName, customerRegistorNo, auth, leader, firstName, lastName, userName, userEmail, userTelNo, userTelNoCtrCd, idpStatus}) {

    if (user.auth !== AUTH_GROUP.BespinMiddleManager) {
      delete user.leader
    }

    return APICaller.post('/api/v1/users', user)
  },

  /**
   * 사용자 정보 업데이트
   * @param  {String} params.auth 권한
   * @param  {String} params.leader 조회 권한
   * @param  {String} params.userEmail 이메일
   * @param  {String} params.userId 사용자 ID
   */
  putUsers (user = {userId, userEmail, auth, leader}) {
    if (user.auth !== AUTH_GROUP.BespinMiddleManager) {
      delete user.leader
    }
    return APICaller.put('/api/v1/users', user)
  },

  /**
   * 사용자 조회 상세
   * @param  {String} userId userId
   */
  getUsersWithUserId (userId) {
    return APICaller.get(`/api/v1/users/${userId}`)
  },

  /**
   * 사용자 OTP 정보 조회 
   * @param  {String} userId userId
   */
  getUserOtpWithUserId(userId){
    return APICaller.get(`/api/v1/users/${userId}/otp`)
  },

  /**
   * 사용자 상태 변경
   * @param  {String} userId userId
   * @param  {String} useYn useYn
   */
  putUsersStatusWithUserIdAndUseYn (userId, useYn) {
    return APICaller.put(`/api/v1/users/${userId}/status/${useYn}`)
  },
  deleteUserWithdraw(){
    return APICaller.delete(`/acl/api/v1/users/withdraw`)
  },
  putUserSecurity (userId, disableMultiLoginYn, useOtp, deleteUserOtpId) {
    return APICaller.put(`/api/v1/users/security`, {userId, disableMultiLoginYn, useOtp, deleteUserOtpId})
  },
  

  /**
   * cardAuth
   */
  postUsersCardAuth () {
    //TODO  api call ->   redirect
    return APICaller.post('/api/v1/users/card-auth')
  },

  /**
   * cardAuthResult
   */
  postUsersCardAuthResult () {
    //TODO api call -> redirect
    return APICaller.post('/api/v1/users/card-auth-result')
  },

  /**
   * 사용자 비밀번호 변경 가능 확인
   * @param  {String} params.password
   * @param  {String} params.passwordConfirm
   */
  getUsersCheckPassword ({password, passwordConfirm}) {
    return APICaller.get('/api/v1/users/check-password', {password, passwordConfirm})
  },

  /**
   * 초기 비밀번호 설정 완료 처리
   */
  postUsersInitPassword () {
    return APICaller.post('/api/v1/users/init-password')
  },

  /**
   * 관리자 사용자 정보 수정
   * @param  {String} params.auth 권한
   * @param  {String} params.leader 조회 권한
   * @param  {String} params.password 비밀번호
   * @param  {String} params.passwordConfirm passwordConfirm
   * @param  {String} params.remark 전화번호
   * @param  {String} params.result result
   * @param  {String} params.sns1 SNS1
   * @param  {String} params.sns1Id SNS1 ID
   * @param  {String} params.sns2 SNS2
   * @param  {String} params.sns2Id SNS2 ID
   * @param  {String} params.snsGubun SNS 구분
   * @param  {String} params.userEmail 이메일
   * @param  {String} params.userId 사용자 ID
   */
  postUsersMaster (user = {auth, leader, password, passwordConfirm, firstName, lastName, userTelNoCtrCd, remark, result, sns1,
    sns1Id, sns2, sns2Id, snsGubun, userEmail, userId, registCompanyName, locale}) {

    if (user.auth !== AUTH_GROUP.BespinMiddleManager) {
      delete user.leader
    }

    return APICaller.post('/api/v1/users/master', user)
  },

  /**
   * 사용자 비밀번호 체크
   * @param  {String} params.password password
   */
  getUsersPassword ({password}) {
    return APICaller.get('/api/v1/users/password', {password})
  },

  /**
   * 비밀번호 초기화
   * @param  {String} params.userEmail userEmail
   */
  putUsersResetPassword ({userEmail}) {
    return APICaller.put('/api/v1/users/reset-password', {userEmail})
  },

  /**
   * 사용자 비밀번호 변경
   * @param  {String} params.password password
   * @param  {String} params.passwordConfirm passwordConfirm
   */
  putUsersUpdatePassword ({password, passwordConfirm}) {
    const passwordChangePayLoad = {
      "newCredential": password,
      "newCredentialConfirm": passwordConfirm
    }

    return APICaller.put('/api/v1/users/update-password', passwordChangePayLoad)
  },

  /**
   * 로그인한 사용자 최신 정보 조회
   */
  getUsersUserInfo () {
    return APICaller.get('/api/v1/users/user-info')
  },
  getUesrList(payload){
    return APICaller.get('/api/v1/users', payload)
  },
  getIDPUesrList(payload){
    return APICaller.get('/acl/api/v1/users', payload)
  },
  getUserGroup ({ serviceCode, siteCode,userEmail}) {
    return APICaller.get(`/acl/api/v1/${serviceCode}/${siteCode}/groupRel`, { userEmail})
  },

  getInnerUserInfo({userEmail}){
    return APICaller.get(`/api/v1/users/userDetail/${userEmail}`)
  },
  updateUserCustomer({userEmail, customerCode, customerDeptCode}) {
    return APICaller.put(`/api/v1/users/customer`, {userEmail, customerCode, customerDeptCode})
  }
}

export default UserServices



// WEBPACK FOOTER //
// ./src/services/UserServicies.js